import 'core-js/fn/object/assign';
import 'intl';
import dva from 'dva';
import './index.less';
import 'react-dom';
import '@babel/polyfill';
import { browserHistory } from 'dva/router';
import createLoading from 'dva-loading';
import moment from 'moment';
import * as i18n from '../i18n';
import { CHINESE, CHINESE_HK, ENGLISH } from '../utils/constants';
import { addLocaleData } from 'react-intl';

require('es6-promise').polyfill();

addLocaleData(i18n[CHINESE]);
addLocaleData(i18n[ENGLISH]);
addLocaleData(i18n[CHINESE_HK]);
moment.locale(CHINESE);

// 1. Initialize
const app = dva({
  history: browserHistory,
  onError: e => {
    window.console.error(e);
    if (e.message) {
      //不弹没有错误信息的error
      // message.error(e.message);
    }
  }
});

// 2. Plugins
app.use(createLoading());

// 3. Model
app.model(require('../models/i18n').default);
app.model(require('../models/login').default);
app.model(require('../models/menu').default);
app.model(require('../models/top').default);

app.model(require('../models/meeting').default);
app.model(require('../models/account').default);
app.model(require('../models/deptUserManage').default);
app.model(require('../models/role').default);
app.model(require('../models/support').default);
app.model(require('../models/meetingList').default);
app.model(require('../models/roomDevice').default);

app.model(require('../models/meetingInfo').default);
app.model(require('../models/meetingReport').default);
app.model(require('../models/roomReport').default);
app.model(require('../models/userReport').default);
app.model(require('../models/roomReportAbnormally').default);
app.model(require('../models/userReportAbnormally').default);
app.model(require('../models/roomReportDetails').default);
app.model(require('../models/roomAbnormallyDetail').default);
app.model(require('../models/userAbnormallyDetail').default);
app.model(require('../models/roomOccupyReport').default);
app.model(require('../models/meetingBillReport').default);

app.model(require('../models/customReport').default);
app.model(require('../models/monitor').default);
app.model(require('../models/fault').default);
app.model(require('../models/personalization').default);
app.model(require('../models/meetingAudit').default);
app.model(require('../models/svcAudit').default);
app.model(require('../models/meetingControl').default);
app.model(require('../models/personal').default);
app.model(require('../models/appIndexConf').default);
app.model(require('../models/sysParam').default);
app.model(require('../models/roomZone').default);
app.model(require('../models/meetingRelease').default);
app.model(require('../models/license').default);

// 4. Router
app.router(require('../router').default);

// 5. Start
app.start('#root');



// WEBPACK FOOTER //
// ./src/pages/index.js